import { Insurance } from "../models/insurance"
import { Insurance as ZiphyInsurance } from "../models/ziphy"

export function convertZMRtoOutreachInsurance(zmr:ZiphyInsurance):Insurance {
    const payerString = zmr.provider_id?.toString();
    return {
        memberFirstName:zmr.member_first_name,
        memberLastName:zmr.member_last_name,
        memberId:zmr.member_id,
        policyHolder:zmr.policy_holder,
        providerName:zmr.provider_name,
        payerId:payerString,
        groupId:zmr.group_id,
        status:zmr.status,
        isPrimary:zmr.is_primary,
        type:zmr.type,
        deleted_time:zmr.deleted_time,
    } as Insurance
}

export function convertOutreachtoZMRInsurance(outreach:Insurance):ZiphyInsurance {
    return {
        member_first_name:outreach.memberFirstName,
        member_last_name:outreach.memberLastName,
        member_id:outreach.memberId,
        policy_holder:outreach.policyHolder,
        provider_name:outreach.providerName,
        is_primary:outreach.isPrimary,
        type:outreach.type,
        deleted_time:outreach.deleted_time,
        ...(outreach.payerId && outreach.payerId?.trim() !== '' ? {provider_id:outreach.payerId} : {}),
        ...(outreach.groupId && outreach.groupId?.trim() !== '' ? {group_id:outreach.groupId} : {})
    } as ZiphyInsurance;
}